export default function toInputString(val: any): string {
    return val != null ? "" + val : "";
}

export function toInputObject(val: any): string {
    return val != null ? val : {};
}
